import React from 'react'

// Deps
import { connect } from 'react-redux';

// Partials
import Link from 'views/shared/partials/link'

const mapStateToProps = (state, ownProps) => {
	return {
		currentPage: state.site.currentPage,
	};
};

const Breadcrumbs = (props) => {
	return (
		<section className="section breadcrumbs">
			<Link className="breadcrumbs-link" href="dashboard">Anasayfa</Link>
			{props.currentPage.group === 'settings' &&
				<span className="breadcrumbs-link">Ayarlar</span>
			}
			{props.midSections &&
				<React.Fragment>
					{props.midSections.map((section, nth) => {
						if(typeof(section) === 'string') {
							return (
								<span className="breadcrumbs-link" key={nth}>{section}</span>
							);
						}
						else if(section.title) {
							return (
								<Link
									className="breadcrumbs-link"
									key={nth}
									href={section.href}
									params={section.params}>
									{section.title}
								</Link>
							)
						}
						else {
							return (
								<Link
									className="breadcrumbs-link"
									key={nth}
									href={section.href}
									params={section.params}>
								</Link>
							)
						}
					})}
				</React.Fragment>
			}
			<span>{props.currentPage.data.linkTitle}</span>
		</section>
	)
}


export default connect(mapStateToProps)(Breadcrumbs);
